import listQuestionsDoc from './listQuestionsDoc';
import type {Question, QuestionStatus} from '@cp/model';

export interface FetchQuestionForReviewDocParams {
  moduleId: string;
  topics?: string[];
  difficulty?: number;
  status?: QuestionStatus;
  skip?: number;
}

export default async function fetchQuestionForReviewDoc(
  params: FetchQuestionForReviewDocParams,
): Promise<Question | null> {
  const rows = await listQuestionsDoc({
    moduleId: params.moduleId,
    topics: params.topics,
    difficulty: params.difficulty,
    status: params.status,
    limit: 1,
    offset: params.skip ?? 0,
  });
  return rows[0] ?? null;
}
